<template>
    <layout-basic class="home-section">
        <section class="hero" style="margin-top: 50px;">
            <div class="hero-body" style="border-bottom: 1px solid #dbdbdb">
                <div class="container has-text-centered">
                    <h2 class="subtitle">The Global Print Network Solution</h2>
                    <h1 class="title">Order your print products straight from your browser with Cloudprinter.com</h1>
                    <a href="https://www.cloudprinter.com" style="text-decoration: underline;">Read more</a>
                </div>
            </div>
        </section>

        <section class="section">
            <div id="how-it-works" class="container has-text-centered">
                <h2 class="title" style="font-weight: bold; color: #055DC2;">How does it work?</h2>
                <div class="columns is-multiline is-centered">
                    <div class="column is-8 is-4-widescreen">
                        <div class="block"><img src="/img/1.svg" alt=""></div>
                        <h4 class="title"><small class="number">1</small>Configure your order</h4>
                        <p>Select and apply product options to your order.</p>
                    </div>
                    <div class="column is-8 is-4-widescreen">
                        <div class="block"><img src="/img/2.svg" alt=""></div>
                        <h4 class="title"><small class="number">2</small>Select the shipping</h4>
                        <p>Set a delivery address and shipping option anywhere in the world</p>
                    </div>
                    <div class="column is-8 is-4-widescreen">
                        <div class="block"><img src="/img/3.svg" alt=""></div>
                        <h4 class="title"><small class="number">3</small>Post to Cloudprinter.com</h4>
                        <p>Push a new order to Cloudprinter.com</p>
                    </div>
                </div>

                <template>
                    <section>
                        <button class="button is-primary"
                                @click="isComponentModalActive = true"
                                style="margin-top: 30px;">
                            Learn more
                        </button>
                    </section>
                </template>

            </div>
        </section>

        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card
                 trap-focus
                 aria-role="dialog"
                 aria-modal>
            <LearnMore></LearnMore>
        </b-modal>

    </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/LayoutBasic'
import LearnMore from '@/components/LearnMore'
import globalPackageVersion from 'global-package-version'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    LayoutBasic,
    LearnMore
  },

  data () {
    return {
      isComponentModalActive: false,
      backendVersions: {},
      frontendVersions: {},
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({ currentUser: 'cpAuth/currentUser' })
  },

  mounted () {
    globalPackageVersion(require('@/../package.json'))
    globalPackageVersion(require('vue-router/package.json'))
    globalPackageVersion(require('vuex/package.json'))
    globalPackageVersion(require('buefy/package.json'))
    globalPackageVersion(require('bulma/package.json'))
    globalPackageVersion(require('axios/package.json'))
    globalPackageVersion(require('webpack/package.json'))
  }
}
</script>
